export const namespaced = true

/*
* localCache är för data som sparas lokalt på enheten tillsvidare, består mellan olika inloggade sessioner
*/

export const state = {
  ignoreAppInstallation: false
}

export const mutations = {
  SET_IGNORE_APP_INSTALLATION (state, val) {
    state.ignoreAppInstallation = val
    localStorage.setItem('LOCAL_CACHE_IGNORE_APP_INSTALLATION', val ? '1' : '0')
  }
}

export const actions = {
  initialise ({ commit }) {
    // Tar bort gamla localstorage key som inte används längre, kan tas bort efter ett tag
    localStorage.removeItem('LOCAL_SETTING_IGNORE_APP_INSTALLATION')

    let val = null

    val = localStorage.getItem('LOCAL_CACHE_IGNORE_APP_INSTALLATION')
    val == null ? val = false : val = (val === '1') // false default
    commit('SET_IGNORE_APP_INSTALLATION', val)
  }
}
